<template>
  <div class="reset-container">
    <div class="reset-card shadow">
      <h3 class="text-center mb-4 text-body-emphasis">Redefinir Senha</h3>

      <!-- Mensagem de sucesso com bordas suaves -->
      <div v-if="mensagemSucesso" class="alert alert-success border-0 shadow-sm text-center">
        <i class="bi bi-check-circle-fill fs-4 d-block mb-2 text-success"></i>
        <p class="mb-0">{{ mensagemSucesso }}</p>
        <router-link to="/" class="btn btn-primary mt-3 w-100">Ir para o Login</router-link>
      </div>

      <form @submit.prevent="handleReset" v-else>
        <!-- Mensagem de erro com bordas suaves -->
        <div v-if="erro" class="alert alert-danger border-0 shadow-sm">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ erro }}
        </div>

        <div class="mb-3">
          <label for="senha" class="form-label">Nova Senha</label>
          <div class="input-group">
            <input :type="showSenha ? 'text' : 'password'" class="form-control" id="senha" name="new-password" autocomplete="new-password" v-model="senha" required placeholder="••••••••">
            <button class="btn btn-outline-secondary" type="button" @click="showSenha = !showSenha" tabindex="-1" :title="showSenha ? 'Ocultar senha' : 'Mostrar senha'">
              <i :class="['bi', showSenha ? 'bi-eye-slash' : 'bi-eye']"></i>
            </button>
          </div>
        </div>

        <div class="mb-4">
          <label for="confirmarSenha" class="form-label">Confirmar Nova Senha</label>
          <div class="input-group">
            <input :type="showConfirmarSenha ? 'text' : 'password'" class="form-control" id="confirmarSenha" name="new-password" autocomplete="new-password" v-model="confirmarSenha" required placeholder="••••••••">
            <button class="btn btn-outline-secondary" type="button" @click="showConfirmarSenha = !showConfirmarSenha" tabindex="-1" :title="showConfirmarSenha ? 'Ocultar senha' : 'Mostrar senha'">
              <i :class="['bi', showConfirmarSenha ? 'bi-eye-slash' : 'bi-eye']"></i>
            </button>
          </div>
        </div>

        <div class="d-grid gap-2">
          <button type="submit" class="btn btn-primary" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Salvar Nova Senha
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/services/api' // GUARDIÃO: Importação do interceptor API em vez do axios puro

defineOptions({
  name: 'RedefinirSenha'
})

const route = useRoute()

const token = ref(null)
const senha = ref('')
const confirmarSenha = ref('')
const showSenha = ref(false)
const showConfirmarSenha = ref(false)
const erro = ref(null)
const isLoading = ref(false)
const mensagemSucesso = ref(null)

onMounted(() => {
  token.value = route.query.token
  if (!token.value) {
    erro.value = 'Token de redefinição inválido ou em falta.'
  }
})

const handleReset = async () => {
  isLoading.value = true
  erro.value = null

  if (senha.value !== confirmarSenha.value) {
    erro.value = 'As senhas não coincidem.'
    isLoading.value = false
    return
  }

  try {
    // GUARDIÃO: Utilizando a instância configurada da API
    const response = await api.post('/Auth/redefinir-senha', {
      token: token.value,
      senha: senha.value,
      confirmarSenha: confirmarSenha.value
    })
    mensagemSucesso.value = response.data.message
    // A rota de push foi comentada propositadamente caso prefira que o utilizador clique no botão de sucesso
    // router.push('/')
  } catch (error) {
    // --- LÓGICA DE ERRO APRIMORADA ---
    if (error.response && error.response.status === 400) {
      // Tenta extrair a primeira mensagem de erro de validação do .NET Core
      const validationErrors = error.response.data.errors
      if (validationErrors) {
        const firstErrorField = Object.keys(validationErrors)[0]
        erro.value = validationErrors[firstErrorField][0]
      } else {
        // Fallback para outros Bad Requests
        erro.value = error.response.data.message || 'Dados inválidos. Verifique o formulário.'
      }
    } else {
      erro.value = 'Não foi possível conectar ao servidor. Tente novamente mais tarde.'
    }
    console.error('Erro ao redefinir senha:', error)
  } finally {
    isLoading.value = false
  }
}
</script>

<style scoped>
/* GUARDIÃO: Variáveis CSS do Bootstrap 5 para suportar Dark Mode automaticamente */
.reset-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--bs-tertiary-bg);
  transition: background-color 0.3s ease;
}

.reset-card {
  width: 100%;
  max-width: 450px;
  padding: 2.5rem;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>
